export default function () {
	return {
		progress: 'all',
		search: '',
		loading: false,
		selected_areas: {
			value: 'all'
		},
		live_class_status: null,
		live_class_is_online: false,
		selected_groups: {
			value:'all'
		},
		selected_tags: {
			value:'all'
		}
	}
}
